import { render, staticRenderFns } from "./AlarmReason.vue?vue&type=template&id=13396560&"
import script from "./AlarmReason.vue?vue&type=script&lang=js&"
export * from "./AlarmReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports